import { useState, useEffect } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { Menu } from '../Menu'
import s from './HtmlTemplates.scss'
import Select from 'react-select'
import { HtmlProposalLibrary } from 'components/common/HtmlProposalLibrary'
import { makeGetRequest } from 'utils/api'
import { useLoading } from 'hooks'

const HtmlTemplates = ({
  userHtmlTemplates,
  selectedTemplate,
  setSelectedTemplate,
  iDealHtmlTemplates
}) => {
  const [page, setPage] = useState(selectedTemplate?.subtype ?? 'ideal')
  const [leftSelectedIndex, setLeftSelectedIndex] = useState('')
  const [middleSelectedIndex, setMiddleSelectedIndex] = useState('')
  const [templateOptions, setTemplateOptions] = useState([])
  const [, withLoadingLocks] = useLoading()

  useEffect(() => {
    if (!middleSelectedIndex && middleSelectedIndex !== 0) return
    setSelectedTemplate(() => ({
      proposalType: 'HTML',
      subtype: 'ideal',
      value: {
        id: iDealHtmlTemplates[leftSelectedIndex].id,
        thumbnailUrl: templateOptions[middleSelectedIndex].coverUrl
      }
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [middleSelectedIndex])

  return (
    <div className={s.wrapper}>
      <Container style={{ height: '100%' }}>
        <Row style={{ height: '100%' }}>
          <Col lg="2">
            <Menu page={page} setPage={setPage} />
          </Col>
          <Col lg="10" style={{ height: '100%' }}>
            {page === 'yours' ? (
              <Select
                value={selectedTemplate?.subtype === 'yours' ? selectedTemplate.value : null}
                onChange={async value => {
                  const { content } = await withLoadingLocks(
                    makeGetRequest(`/v1/proposaltemplates/${value.id}`)
                  )
                  setSelectedTemplate(() => ({
                    proposalType: 'HTML',
                    subtype: 'yours',
                    value: { ...value, content }
                  }))
                }}
                options={userHtmlTemplates}
                className={s.select}
              />
            ) : (
              <HtmlProposalLibrary
                predesignedTemplates={iDealHtmlTemplates}
                setLeftSelectedIndexCb={setLeftSelectedIndex}
                setMiddleSelectedIndexCb={setMiddleSelectedIndex}
                setTemplateOptionsCb={setTemplateOptions}
              />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default HtmlTemplates
